import { Box, Modal } from "@mui/material";
import React, { type ReactNode } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  style?: React.CSSProperties;
  fullScreen?: boolean;
};

const AdminModal = ({
  open,
  onClose,
  children,
  width,
  style,
  fullScreen = false,
}: Props) => {
  const defaultStyle = fullScreen
    ? {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        transform: "none",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
      }
    : {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        width: "100%",
        maxWidth: width ?? 500,
        maxHeight: "96vh",
        overflowY: "auto",
        borderRadius: 2,
      };

  return (
    <Modal open={open} onClose={() => onClose()}>
      <Box sx={{ ...defaultStyle, ...style }}>{children}</Box>
    </Modal>
  );
};

export { AdminModal };
